import { useQuery } from 'react-query'

import { DeliveryNote } from '@features/deliveryNotes/types/deliveryNote'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { defaultStaleTime } from '../../../config/queryClient'
import { QueryKeys } from '../../../enums/queryKeys'
import { useOrganizationSource } from '../../../hooks'
import { fetchDeliveryNotes } from '../query-api'

interface UseFetchDeliveryNotesResponse {
  deliveryNotes: DeliveryNote[]
  isError: boolean
  isLoading: boolean
}

export const useFetchDeliveryNotes = (): UseFetchDeliveryNotesResponse => {
  const { isSourceZervant } = useOrganizationSource()
  const { organization } = useUserOrganization()

  const {
    data: deliveryNotes,
    isIdle,
    isLoading,
    isError,
  } = useQuery([QueryKeys.DeliveryNotes, organization?.id], fetchDeliveryNotes, {
    enabled: isSourceZervant && !!organization?.id,
    staleTime: defaultStaleTime,
  })

  return {
    deliveryNotes: deliveryNotes || [],
    isError,
    isLoading: isIdle || isLoading,
  }
}
